import { createContext } from 'react';

const AppStateContext = createContext(null);
const AppDispatchContext = createContext(null);
const StateContext = createContext(null);

export { StateContext, AppStateContext, AppDispatchContext };
